import { createJSONStorage } from 'zustand/middleware'

// Shared persistence adapter for Zustand `persist`.
//
// - Backs onto sessionStorage, so drafts survive a page refresh but are
//   cleared when the tab/browser closes (smaller exposure window than
//   localStorage on shared machines).
// - Adds a TTL so stale drafts self-expire.
// - Plaintext JSON: client-side encryption with a bundled key is
//   obfuscation, not security, so we don't ship it. Never persist
//   tokens/PII here.
export const createExpiringStorage = (ttlMs) =>
  createJSONStorage(() => ({
    getItem: (name) => {
      const raw = sessionStorage.getItem(name)
      if (!raw) return null
      try {
        const { value, expiry } = JSON.parse(raw)
        if (expiry && Date.now() > expiry) {
          sessionStorage.removeItem(name)
          return null
        }
        return value
      } catch {
        return null
      }
    },
    setItem: (name, value) => {
      sessionStorage.setItem(
        name,
        JSON.stringify({ value, expiry: Date.now() + ttlMs }),
      )
    },
    removeItem: (name) => sessionStorage.removeItem(name),
  }))

// Default draft lifetime: 2 hours (matches the original vehicle draft TTL).
export const DRAFT_TTL_MS = 1000 * 60 * 60 * 2
